import { render } from "./EditMagasin.vue?vue&type=template&id=d88782a0&ts=true"
import script from "./EditMagasin.vue?vue&type=script&lang=ts"
export * from "./EditMagasin.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__